import React from 'react'
import ReactDOM from 'react-dom'
import App from './startup/App'
import { initializeAccount, authAccount } from 'utils/account'

authorizeUser()

async function authorizeUser () {
  initializeAccount()
  try {
    await authAccount()
    ReactDOM.render(<App />, document.getElementById('root'))
  } catch (err) {
    let errorContent = `Ошибка авторизации на сервере <strong>${process.env.MEDIA_IDP_HOST}</strong>`

    if (err.response && err.response.status) {
      errorContent += `<br/>Код ошибки: ${err.response.status}`
    }
    document.getElementById('root').innerHTML = errorContent
  }
}



// WEBPACK FOOTER //
// ./src/index.js